"use strict";

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var GraphQlLdContext_1 = require("../context/GraphQlLdContext");

var QueryEngine_1 = require("../QueryEngine");

var _require = require('@solid/react'),
    useWebId = _require.useWebId,
    useLiveUpdate = _require.useLiveUpdate; // tslint:disable-line:no-var-requires


var valueState = {
  loading: true,
  error: undefined,
  data: undefined
};
/**
 * A hook for executing a GraphQL-LD query.
 * @param {QueryArgs} queryArgs Query arguments, which must contain at least a query.
 * @return {IQueryValueState} The query response.
 */

function useQuery(queryArgs) {
  // Grab information from other hooks
  var context = react_1.useContext(GraphQlLdContext_1.getGraphQlLdContext());
  var webId = useWebId();
  var latestUpdate = useLiveUpdate(); // Retrieve the latest query result

  var _react_1$useState = react_1.useState(valueState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      _react_1$useState2$ = _react_1$useState2[0],
      loading = _react_1$useState2$.loading,
      error = _react_1$useState2$.error,
      data = _react_1$useState2$.data,
      update = _react_1$useState2[1];

  react_1.useDebugValue(error || data); // Initialize the query engine

  react_1.useEffect(function () {
    var engine = new QueryEngine_1.QueryEngine(context.client);
    engine.evaluate(queryArgs, function (changed) {
      return update(function (current) {
        return Object.assign(Object.assign({}, current), changed);
      });
    });
    return function () {
      return engine.destroy();
    };
  }, [context.client, latestUpdate, webId]); // Return the state components

  return {
    loading: loading,
    error: error,
    data: data
  };
}

exports.useQuery = useQuery;